import PhoneArea from "components/PhonePreview/PhoneArea"
import React from "react"

const ResultPreview = ({
  menu_bg_color,
  menu_font_color,
  headline = "",
  bgImage,
  image,
  bgColor,
  textColor,
  description = "",
  results = [],
}) => {
  return (
    <PhoneArea>
      <div
        style={{
          backgroundImage: `url(${bgImage})`,
          backgroundColor: bgColor,
          width: "105%",
          height: "105%",
          backgroundSize: "cover",
          marginLeft: "-5px",
          backgroundPosition: "center center",
        }}
      >
        <div
          style={{
            width: "100%",
            height: "70px",
            backgroundColor: menu_bg_color,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <i
            className="bx bx-sm bx-x py-1 px-1"
            style={{ cursor: "pointer", color: menu_font_color }}
          />
          <p
            style={{
              textAlign: "center",
              color: menu_font_color,
              fontSize: "14px",
            }}
          >
            {headline}
          </p>
        </div>
        {image && (
          <div
            style={{
              backgroundImage: `url(${image})`,
              width: "100%",
              height: "20%",
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          />
        )}

        <div
          style={{
            backgroundColor: "black",
            width: "90%",
            height: "80px",
            margin: "10px 6px",
            borderRadius: "10px",
            background: `linear-gradient(${results[0]?.topGradientColor}, ${results[0]?.bottomGradientColor})`,
          }}
        >
          <p
            className="mx-1 pt-2 my-0"
            style={{
              color: results[0]?.textColor || "white",
              fontSize: "18px",
            }}
          >
            {results[0]?.title || ""}
          </p>
          <p
            className="mx-1 my-1"
            style={{ color: results[0]?.textColor || "white" }}
          >
            {results[0]?.description || ""}
          </p>
        </div>
        <p className="mx-1 my-1" style={{ color: textColor }}>
          {description}
        </p>
      </div>
    </PhoneArea>
  )
}

export default ResultPreview
